<ng-template #createTemplate let-item>
	<div class="flex justify-between items-center">
		<div class="mr-3 whitespace-nowrap">
			<span *ngIf="!item?.prefilledNewClient">{{ item?.searchValue }}</span>
			<span *ngIf="item?.prefilledNewClient">{{
				item?.prefilledNewClient | clientName
			}}</span>
		</div>
		<app-button
			(click)="create()"
			size="small"
			[testHook]="testHooks.CreateButton"
			>Create</app-button
		>
	</div>
</ng-template>

<ng-template #itemTemplate let-item>
	<div *ngIf="item.type === clientTypes.PERSON" class="whitespace-nowrap">
		<app-icon
			[icon]="!item.leap?.cardId ? ICON.PERSON : ICON.ADDRESS_CARD"
			class="mr-2"
			[testHook]="testHooks.PersonIcon"
		></app-icon
		>{{ item | clientName }}
	</div>
	<div *ngIf="item.type === clientTypes.CORPORATION" class="whitespace-nowrap">
		<app-icon
			[icon]="ICON.CORPORATION"
			class="mr-2"
			[testHook]="testHooks.CorporationIcon"
		></app-icon>
		{{ item.name }}
	</div>
	<div *ngIf="item.type === clientTypes.BUILDER" class="whitespace-nowrap">
		<app-icon
			[icon]="ICON.BUILDER"
			class="mr-2"
			[testHook]="testHooks.BuilderIcon"
		></app-icon>
		{{ item.name }}
	</div>
</ng-template>

<ng-container *ngIf="vm$ | async as vm">
	<div *ngIf="!vm.selected" (clickOutside)="vm.showDropdown = false">
		<app-input
			[disabled]="vm.disabled"
			[endIcon]="vm.showDropdown ? ICON.UP : ICON.DOWN"
			(click)="toggleShowDropdown()"
			(debounce)="debounce($event)"
			[(ngModel)]="vm.searchValue"
			[placeholder]="vm.placeholder"
			[testHook]="testHooks.Input"
		></app-input>
		<div class="relative">
			<app-dropdown-options
				class="w-full"
				[show]="vm.searchValue && vm.showDropdown"
				[loading]="vm.loading"
				[itemGroups]="[
					{
						items: [
							{
								searchValue: vm.searchValue,
								prefilledNewClient: vm.prefilledNewClient,
							},
						],
						template: createTemplate,
						type: userSelectGroupType.CREATE,
					},
					{
						items: vm.searchClients,
						template: itemTemplate,
						title: 'Search results',
						noResultsMessage: vm.noResultsMessage,
						type: userSelectGroupType.SELECT_ADD,
					},
				]"
				(onSelect)="onAddSelect($event)"
				[testHook]="testHooks.DropdownOptions"
			>
			</app-dropdown-options>
			<app-dropdown-options
				class="w-full"
				[show]="!vm.searchValue && vm.showDropdown"
				[itemGroups]="[
					{
						title: vm.title,
						items: vm.filteredClients,
						noResultsMessage: 'No clients selected. Type to search or add.',
						template: itemTemplate,
						type: userSelectGroupType.SELECT_CURRENT,
					},
					{
						items: [{ prefilledNewClient: vm.prefilledNewClient }],
						template: createTemplate,
						type: userSelectGroupType.CREATE,
					},
				]"
				(onSelect)="onCurrentSelect($event)"
				[testHook]="testHooks.DropdownOptions1"
			>
			</app-dropdown-options>
		</div>
	</div>

	<div *ngIf="vm.selected">
		<div class="border rounded-xl py-1 px-2 border-grey-light">
			<app-pill
				[remove]="true"
				(onRemove)="onRemove()"
				[testHook]="testHooks.Pill"
				>{{ vm.selectedName }}</app-pill
			>
		</div>
	</div>
</ng-container>
